var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpanish = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_930_23251",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_930_23251)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.8H24V3H0V7.8Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21H24V16.2H0V21Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.2H24V7.80005H0V16.2Z",
    fill: "#FFD133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28564 11.4H7.4285V12H6.28564V11.4Z",
    fill: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24656 11.4931C5.23117 11.2992 5.38436 11.1334 5.57885 11.1334H6.99265C7.18714 11.1334 7.34032 11.2992 7.32494 11.4931L7.18674 13.2344C7.14944 13.7044 6.75718 14.0667 6.28575 14.0667C5.81431 14.0667 5.42206 13.7044 5.38476 13.2344L5.24656 11.4931Z",
    stroke: "#A41517",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14282 12H7.42854V12.6H6.85711L6.28568 13.8L5.71425 12.6H5.14282V12Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.42847,
    y: 10.2,
    width: 1.14286,
    height: 4.2,
    rx: 0.571429,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10.2,
    width: 1.14286,
    height: 4.2,
    rx: 0.571429,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14282 9.96C5.14282 9.42981 5.57263 9 6.10282 9H6.46854C6.99873 9 7.42854 9.42981 7.42854 9.96C7.42854 10.0925 7.32108 10.2 7.18854 10.2H5.38282C5.25027 10.2 5.14282 10.0925 5.14282 9.96Z",
    fill: "#A41517"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpanish);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spanish.c66ac5f14b2ada191804864f57c157e0.svg";